var map = {
	"./Apt.png": "d75a",
	"./Brick.png": "ac97",
	"./Liza.png": "ac17",
	"./Roof.png": "2764",
	"./Stairs.png": "1dae",
	"./Wonder.png": "9e90",
	"./Younger.png": "0620"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db97";